var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 12.1003C15.6652 12.1003 18.2389 9.52651 18.2389 6.36068C18.2389 3.19484 15.6652 0.621094 12.4993 0.621094C9.33352 0.621094 6.75977 3.19484 6.75977 6.36068C6.75977 9.52651 9.33352 12.1003 12.4993 12.1003ZM12.4993 2.43359C14.6623 2.43359 16.4264 4.19776 16.4264 6.36068C16.4264 8.52359 14.6623 10.2878 12.4993 10.2878C10.3364 10.2878 8.57227 8.52359 8.57227 6.36068C8.57227 4.19776 10.3364 2.43359 12.4993 2.43359Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1788 15.7373C15.98 13.3206 9.02 13.3206 2.82125 15.7373C1.54042 16.2327 0.71875 17.4531 0.71875 18.8306V20.8606C0.71875 22.6973 2.205 24.1836 4.04167 24.1836H20.9583C22.795 24.1836 24.2812 22.6973 24.2812 20.8606V18.8306C24.2812 17.4531 23.4596 16.2327 22.1788 15.7373ZM22.4688 20.8606C22.4688 21.6944 21.7921 22.3711 20.9583 22.3711H4.04167C3.20792 22.3711 2.53125 21.6944 2.53125 20.8606V18.8306C2.53125 18.2023 2.90583 17.6465 3.48583 17.429C6.37375 16.3052 9.40667 15.7252 12.5 15.7252C15.5933 15.7252 18.6262 16.2931 21.5142 17.429C22.0942 17.6586 22.4688 18.2023 22.4688 18.8306V20.8606Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInformation);
export default __webpack_public_path__ + "static/media/client_information.24a359fb50b234c2d4788b2be0459a85.svg";
export { ForwardRef as ReactComponent };